import {
  jb_news_page_hero_css_default
} from "./chunk.GJOFCK22.js";
import {
  Spaceable
} from "./chunk.LK5OUX7S.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-news-page-hero/jb-news-page-hero.ts
var JbNewsPageHero = class extends Spaceable(r) {
  _getContentSpacingProperties() {
    return { type: "no-vertical-space" };
  }
  render() {
    return ke`<article>
      ${this.breadcrumbs && ke`
          <jb-breadcrumbs>
            ${this.breadcrumbs.backlink && ke`<jb-breadcrumbs-back-link
              .link=${this.breadcrumbs.backlink.link}
              .text=${this.breadcrumbs.backlink.text}
              slot="backlink"
            ></jb-breadcrumbs-back-link>`}
            ${this.breadcrumbs.items?.map(
      (breadcrumb) => ke`<jb-breadcrumbs-item
                  .link=${breadcrumb.link}
                  .text=${breadcrumb.text}
                  slot="items"
                ></jb-breadcrumbs-item>`
    )}
          </jb-breadcrumbs>
        `}
      <header>
        <div class="intro-section">
          <jb-date date=${this.date}></jb-date>
          ${this.languages?.length && ke`<jb-language-list
              .languages=${this.languages}
              .languageLabel=${this.languagesLabel}
            ></jb-language-list>`}
        </div>
      </header>
      <div class="title">
        ${this.subline && ke`<h5>${this.subline}</h5>`}
        <h1>${this.headline}</h1>
      </div>
      ${this.shareBarLabel && ke`<div class="toolbar">
          ${this.mailSubject && this.shareBarLabel && this.sharingUrl && ke`
            <jb-article-share-bar
              .articleTitle=${this.headline}
              .mailSubject=${this.mailSubject}
              .title=${this.shareBarLabel}
              .shareServices=${this.shareServices}
              .url=${this.sharingUrl}
            ></jb-article-share-bar>
          `}
        </div>`}
      <div class="intro">${this.intro}</div>
      </div>
      <slot></slot>
    </article>`;
  }
};
JbNewsPageHero.styles = jb_news_page_hero_css_default;
__decorateClass([
  n({ type: Object })
], JbNewsPageHero.prototype, "breadcrumbs", 2);
__decorateClass([
  n()
], JbNewsPageHero.prototype, "date", 2);
__decorateClass([
  n()
], JbNewsPageHero.prototype, "headline", 2);
__decorateClass([
  n()
], JbNewsPageHero.prototype, "intro", 2);
__decorateClass([
  n({ type: Array })
], JbNewsPageHero.prototype, "languages", 2);
__decorateClass([
  n()
], JbNewsPageHero.prototype, "languagesLabel", 2);
__decorateClass([
  n()
], JbNewsPageHero.prototype, "mailSubject", 2);
__decorateClass([
  n()
], JbNewsPageHero.prototype, "shareBarLabel", 2);
__decorateClass([
  n({ type: Array })
], JbNewsPageHero.prototype, "shareServices", 2);
__decorateClass([
  n()
], JbNewsPageHero.prototype, "sharingUrl", 2);
__decorateClass([
  n()
], JbNewsPageHero.prototype, "subline", 2);
JbNewsPageHero = __decorateClass([
  customElement("jb-news-page-hero")
], JbNewsPageHero);

export {
  JbNewsPageHero
};
